import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

type SwitchWithLabelProps = {
    isChecked: boolean;
    setIsChecked: (isChecked: boolean) => void;
    label: string;
    id: string;
};

const SwitchWithLabel = ({
    isChecked,
    setIsChecked,
    label,
    id,
}: SwitchWithLabelProps) => (
    <div className="flex items-center gap-2">
        <Switch checked={isChecked} id={id} onCheckedChange={setIsChecked} />
        <Label htmlFor={id}>{label}</Label>
    </div>
);

export default SwitchWithLabel;
